const SHOPS = [
  "Apex Collision Center",
  "Northline Auto Body Works",
  "Precision Coachworks USA",
  "Summit MSO Repair Group",
  "Vanguard Collision Specialists",
];

const Row = () => (
  <div className="flex items-center gap-12 shrink-0">
    {SHOPS.map((shop) => (
      <span key={shop} className="flex items-center gap-12">
        <span>{shop}</span>
        <span aria-hidden="true">•</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    data-testid="client-logo-marquee"
    className="py-8 bg-stone-100 border-b border-[#E7E5E4] overflow-hidden"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 mb-4">
      <span className="text-xs font-mono-ui uppercase tracking-widest text-stone-500">
        Trusted by independent shops & MSOs
      </span>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="mq-track flex items-center gap-12 text-stone-700 font-bold font-serif-display text-sm">
        <Row />
        <Row />
      </div>
    </div>
  </section>
);

export default Marquee;
